module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SV-217aa6b07227bdfb4118f23fc9437e00.png";